import React, {
    useEffect,
    useRef,
    useContext,
    useState,
    useCallback,
} from "react";
import PropTypes from "prop-types";
import { FontSizeContext } from "../../context/fontSizeContext";
import { NavLink } from "react-router-dom";

const NeoinsightsContainer = ({ contRef }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    const { fontSize } = useContext(FontSizeContext);
    const textRefs = useRef([]);
    const [defaultSizes, setDefaultSizes] = useState([]);
    const [modalItem, setModalItem] = useState(null);
    const [blink, setBlink] = useState(true);

    const resetFontSize = useCallback(() => {
        textRefs.current.forEach((element, index) => {
            if (element && defaultSizes[index] !== null) {
                element.style.fontSize = `${defaultSizes[index]}px`;
            }
        });
    }, [defaultSizes]);

    const handleModalOpen = (item) => {
        setModalItem(item);
    };

    const handleModalClose = () => {
        setModalItem(null);
    };

    const adjustFontSize = (change) => {
        textRefs.current.forEach((element) => {
            if (element) {
                const computedStyle = window.getComputedStyle(element);
                const currentSize = parseFloat(computedStyle.fontSize);
                const newSize = currentSize + change;
                element.style.fontSize = `${newSize}px`;
            }
        });
    };

    // Files in the public folder are served from the root URL "/"
    useEffect(() => {
        fetch("../../data/neoinsights.json")
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Failed to fetch JSON");
                }
                return response.json();
            })
            .then((jsonData) => {
                setData(jsonData);
                setLoading(false);
            })
            .catch((error) => {
                console.error("Error loading JSON:", error);
                setLoading(false);
            });
    }, []);

    useEffect(() => {
        if (fontSize === 0) {
            resetFontSize();
        } else {
            adjustFontSize(fontSize);
        }
    }, [fontSize, resetFontSize]);

    useEffect(() => {
        const sizes = textRefs.current.map((element) => {
            if (element) {
                const computedStyle = window.getComputedStyle(element);
                return parseFloat(computedStyle.fontSize);
            }
            return null;
        });
        setDefaultSizes(sizes);
    }, []);

    return (
        <>
            <style>
                {`
                .card-title {
                    color: #008080;
                    font-size: 1.1rem;
                    font-weight: 600;
                }

                .btn-success {
                    background-color: #4CAF50;
                    border: none;
                    box-shadow: 0 4px #2e7d32;
                    font-weight: 500;
                    padding: 10px 20px;
                    border-radius: 20px;
                    color: white;
                    text-decoration: none;
                    display: inline-block;
                }

                .btn-success:hover {
                    background-color: #45a049;
                }

                .modal-backdrop {
                    position: fixed;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background-color: rgba(0, 0, 0, 0.6);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    z-index: 999;
                    cursor: pointer;
                }

                .modal-content {
                    background: white;
                    padding: 30px;
                    border-radius: 10px;
                    max-width: 500px;
                    width: 90%;
                    position: relative;
                }

                .modal-close {
                    position: absolute;
                    top: 10px;
                    right: 15px;
                    font-size: 24px;
                    font-weight: bold;
                    cursor: pointer;
                    color: green;
                }
                `}
            </style>

            <div className="single-service pb-0 pt-10" ref={contRef}>
                <div className="container">
                    <div className="row justify-content-center">
                        {data.map((single, i) => {
                            if (single.isNew == 0) {
                                return (
                                    <div
                                        className="col-xl-4 col-lg-3 col-sm-6 mb-5"
                                        key={i}
                                    >
                                        <div className="sidbar-menu align-items-center pdf-div">
                                            <ul>
                                                <li>
                                                    <NavLink
                                                        target="_blank"
                                                        activeClassName=""
                                                        className="padding-15 pdf-div-trans justify-content-center"
                                                        to="#"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            if (
                                                                single.form ===
                                                                1
                                                            ) {
                                                                handleModalOpen(
                                                                    single
                                                                );
                                                            } else {
                                                                window.open(
                                                                    process.env
                                                                        .PUBLIC_URL +
                                                                        single.link,
                                                                    "_blank"
                                                                );
                                                            }
                                                        }}
                                                    >
                                                        <i className="fa fa-download px-2">
                                                            &nbsp;&nbsp;
                                                        </i>
                                                        <p
                                                            className="font-14 justify-content-center text-center"
                                                            ref={(el) =>
                                                                (textRefs.current[
                                                                    i
                                                                ] = el)
                                                            }
                                                        >
                                                            {single.title}
                                                        </p>
                                                    </NavLink>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                );
                            } else {
                                return (
                                    <div key={i}>
                                        <div
                                            className="row justify-content-center item-mobile"
                                            key={i}
                                        >
                                            <div
                                                className="col-xl-4 col-lg-3 col-sm-6 mb-5 "
                                                key={i}
                                            >
                                                <div className="sidbar-menu align-items-center pdf-div-highlight">
                                                    <ul>
                                                        <li
                                                            style={{
                                                                marginBottom:
                                                                    "0px",
                                                            }}
                                                        >
                                                            <NavLink
                                                                style={{
                                                                    marginLeft:
                                                                        "-5px",
                                                                }}
                                                                target="_blank"
                                                                activeClassName="active"
                                                                className=" pdf-div-trans-highlight justify-content-center"
                                                                to="#"
                                                                onClick={(
                                                                    e
                                                                ) => {
                                                                    e.preventDefault();
                                                                    if (
                                                                        single.form ===
                                                                        1
                                                                    ) {
                                                                        handleModalOpen(
                                                                            single
                                                                        );
                                                                    } else {
                                                                        window.open(
                                                                            process
                                                                                .env
                                                                                .PUBLIC_URL +
                                                                                single.link,
                                                                            "_blank"
                                                                        );
                                                                    }
                                                                }}
                                                            >
                                                                <i className="fa fa-download px-2">
                                                                    &nbsp;&nbsp;
                                                                </i>
                                                                <p
                                                                    className="font-14 justify-content-center text-center"
                                                                    ref={(el) =>
                                                                        (textRefs.current[
                                                                            i
                                                                        ] = el)
                                                                    }
                                                                >
                                                                    {
                                                                        single.title
                                                                    }
                                                                </p>
                                                            </NavLink>
                                                        </li>
                                                        <li
                                                            className="text-center"
                                                            style={{
                                                                marginBottom:
                                                                    "0px",
                                                            }}
                                                        >
                                                            <span className="badge bg-warning text-dark top-0 end-0 m-1">
                                                                New
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="sidbar-menu align-items-center item-desk mb-8">
                                            <ul className="pdf-div-highlight ">
                                                <li
                                                    style={{
                                                        marginBottom: "0px",
                                                    }}
                                                >
                                                    <NavLink
                                                        target="_blank"
                                                        activeClassName="active"
                                                        className=" pdf-div-trans justify-content-center"
                                                        to="#"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            if (
                                                                single.form ===
                                                                1
                                                            ) {
                                                                handleModalOpen(
                                                                    single
                                                                );
                                                            } else {
                                                                window.open(
                                                                    process.env
                                                                        .PUBLIC_URL +
                                                                        single.link,
                                                                    "_blank"
                                                                );
                                                            }
                                                        }}
                                                    >
                                                        <i className="fa fa-download px-2">
                                                            &nbsp;&nbsp;
                                                        </i>
                                                        <p
                                                            className="font-14 justify-content-center text-center"
                                                            ref={(el) =>
                                                                (textRefs.current[
                                                                    i
                                                                ] = el)
                                                            }
                                                        >
                                                            {single.title}
                                                        </p>
                                                    </NavLink>
                                                </li>
                                                <li
                                                    className="text-center"
                                                    style={{
                                                        marginBottom: "0px",
                                                    }}
                                                >
                                                    <span className="badge bg-warning text-dark top-0 end-0 m-1 blink_me">
                                                        New
                                                    </span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                );
                            }
                        })}
                        {/* {data.map((item, i) => (
                            <div
                                className={`col-md-6 col-lg-6 mb-4 d-flex`}
                                key={item.id}
                            >
                                <div
                                    className={`card text-center p-3 shadow-sm h-100 w-100 d-flex flex-column justify-content-between ${
                                        i === 0 ? "highlighted-card" : ""
                                    }`}
                                >
                                    {i === 0 && (
                                        <span className="badge bg-warning text-dark position-absolute top-0 end-0 m-2">
                                            New
                                        </span>
                                    )}
                                    <h5
                                        className="card-title mt-3"
                                        ref={(el) => (textRefs.current[i] = el)}
                                    >
                                        {item.title}
                                    </h5>
                                    <button
                                        className="btn btn-xm btn-primary btn-hover-primary mx-auto"
                                        onClick={() => {
                                            if (item.form === 1) {
                                                handleModalOpen(item);
                                            } else {
                                                window.open(
                                                    process.env.PUBLIC_URL +
                                                        item.link,
                                                    "_blank"
                                                );
                                            }
                                        }}
                                    >
                                        {item.action}
                                    </button>
                                </div>
                            </div>
                        ))} */}
                    </div>
                </div>

                <div className="text-center pt-5">
                    For more details, contact:{" "}
                    <a href="mailto:comms@neogrowth.in">comms@neogrowth.in</a>
                </div>
                <br />
            </div>

            {modalItem && (
                <div
                    className="modal-backdrop"
                    onClick={handleModalClose}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) =>
                        (e.key === "Enter" || e.key === " ") &&
                        handleModalClose()
                    }
                    aria-label="Modal Backdrop"
                >
                    <div
                        className="modal-content"
                        onClick={(e) => e.stopPropagation()}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                e.stopPropagation();
                                handleModalClose();
                            }
                        }}
                    >
                        <button
                            className="modal-close"
                            onClick={handleModalClose}
                            onKeyDown={(e) =>
                                (e.key === "Enter" || e.key === " ") &&
                                handleModalClose()
                            }
                            aria-label="Close Modal"
                        >
                            &times;
                        </button>

                        <h3 style={{ color: "green", marginBottom: "20px" }}>
                            Please Fill Below Details
                        </h3>
                        <hr />
                        <form
                            onSubmit={(e) => {
                                e.preventDefault();
                                const name = e.target.fullName.value.trim();
                                const phone = e.target.phone.value.trim();
                                const email = e.target.email.value.trim();

                                if (!name || !phone || !email) {
                                    alert(
                                        "Please fill all the required fields."
                                    );
                                    return;
                                }

                                const link = document.createElement("a");
                                link.href =
                                    process.env.PUBLIC_URL + modalItem.link;
                                link.download = modalItem.title + ".pdf";
                                link.target = "_blank";
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);

                                handleModalClose();
                            }}
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: "15px",
                                marginTop: "20px",
                            }}
                        >
                            <input
                                name="fullName"
                                type="text"
                                minLength="3"
                                placeholder="Full Name*"
                                required
                                style={{
                                    padding: "10px",
                                    borderRadius: "5px",
                                    border: "1px solid #ccc",
                                }}
                            />
                            <div style={{ display: "flex" }}>
                                <span
                                    style={{
                                        padding: "10px 12px",
                                        background: "#f1f1f1",
                                        border: "1px solid #ccc",
                                        borderRadius: "5px 0 0 5px",
                                    }}
                                >
                                    +91
                                </span>
                                <input
                                    name="phone"
                                    type="text"
                                    pattern="\d*"
                                    minLength="10"
                                    maxLength="10"
                                    placeholder="Phone Number*"
                                    required
                                    style={{
                                        flex: 1,
                                        padding: "10px",
                                        border: "1px solid #ccc",
                                        borderLeft: "none",
                                        borderRadius: "0 5px 5px 0",
                                    }}
                                />
                            </div>
                            <input
                                name="email"
                                type="email"
                                placeholder="Work Email ID*"
                                required
                                style={{
                                    padding: "10px",
                                    borderRadius: "5px",
                                    border: "1px solid #ccc",
                                }}
                            />
                            <button
                                type="submit"
                                className="btn btn-xm btn-primary btn-hover-primary mx-auto"
                                style={{
                                    marginTop: "10px",
                                    alignSelf: "center",
                                    width: "120px",
                                }}
                            >
                                Submit
                            </button>
                        </form>
                    </div>
                </div>
            )}
        </>
    );
};

NeoinsightsContainer.propTypes = {
    data: PropTypes.array,
    contRef: PropTypes.any,
};

export default NeoinsightsContainer;
